import { UserStatus } from "@shared_packages/toolkit/types";
import {
  ISearchFieldConfig,
  SearchFieldType,
} from "../../../../components/advanced-search/AdvancedSearch.interface";

export const usersSearchConfig: ISearchFieldConfig[] = [
  {
    type: SearchFieldType.DATE_RANGE,
    label: "Created date",
    key: "from",
    rangeEndKey: "to",
    placeholder: "From",
    rangeEndPlaceholder: "To",
  },
  {
    type: SearchFieldType.DROPDOWN,
    label: "Status",
    key: "status",
    dropdownValues: [
      { label: "All", value: "" },
      { label: "Active", value: UserStatus.ACTIVE },
      { label: "Pending invitation", value: UserStatus.PENDING },
      { label: "Silent", value: UserStatus.SILENT },
      { label: "Blocked", value: UserStatus.BLOCKED },
      { label: "Banned", value: UserStatus.BANNED },
    ],
  },
  {
    type: SearchFieldType.SEARCH_BY_COMPANY_DROPDOWN,
    label: "Search by company",
    key: "companyId",
  },
];
